// 도구 → 사용자 친화 라벨. app.js(전체)와 dcf.js(부분 중복·표현 상이)에
// 2벌 있던 것을 통합 — 표현이 갈리던 키는 채팅 페이지(app.js) 기준으로 맞춘다.
export const TOOL_LABELS: Record<string, string> = {
  method_guide: "필요한 정보 안내",
  resolve_company: "회사 찾기",
  company_profile: "회사 개요 확인",
  company_financials: "재무 데이터 조회",
  per_multiples: "PER 계산",
  company_documents: "공시·뉴스 조회",
  dcf_sample: "DCF 양식 준비",
  dcf_calculate: "DCF 가치 계산",
  dcf_excel: "DCF 엑셀 만들기",
  intake_upload: "첨부 문서 분석",
  intake_answer: "입력값 반영",
  intake_finalize: "입력 확정",
  peer_select: "유사기업 찾기",
  relative_peer_multiples: "유사기업 배수 계산",
  relative_calculate: "상대가치 계산",
  wacc: "할인율(WACC) 계산",
  beta: "베타 계산",
  kofia_rates: "시장금리 조회",
  volatility: "변동성 계산",
  rcps_value: "RCPS 평가",
  stock_option_value: "스톡옵션 평가",
  bdt_value: "채권 평가",
  buffett_analyze: "기업 정성 분석",
  buffett_pdf: "버핏스코어 PDF 생성",
  portfolio_returns: "포트폴리오 수익률",
  stock_price: "주가 조회",
  company_search: "상장·비상장 회사 검색",
  company_search_by_business: "사업내용으로 기업 찾기",
  company_overview: "기업 개요 조회",
  company_shareholders: "주주 현황 조회",
  patent_holders: "특허 보유 기업 검색",
  patent_applicant_detail: "특허 상세 조회",
  financial_screener: "기업 스크리닝",
  sample_payload: "샘플 입력 준비",
  generate_file: "파일 생성",
  rcps_extract: "RCPS 문서 추출",
  rcps_extract_run: "RCPS 추출 실행",
  stock_price_excel: "주가 엑셀 생성",
  financials_excel: "재무 엑셀 생성",
  company_report: "기업 리포트 생성",
  dcf_set_assumption: "DCF 가정 수정",
  dcf_recalculate: "DCF 재계산",
  dcf_review_readiness: "리뷰 준비도 점검",
  peer_industry_screen: "산업분류 유사기업 선정",
  peer_major_report_search: "공시 선례 검색",

  // ── DeepSearch Graph DB(MCP) — 서버가 도구를 늘려도 미등록 키는 toolLabel 폴백(원본 이름) ──
  dskg_company_profile: "기업 개요",
  dskg_compare: "기업 비교",
  dskg_financials: "재무 지표",
  dskg_financials_history: "재무 추이",
  dskg_price_history: "주가 시계열",
  dskg_why_moving: "주가 변동 원인",
  dskg_dividends: "배당 이력",
  dskg_revenue_mix: "매출 구성",
  dskg_share_structure: "주식 구조",
  dskg_executives: "임원 현황",
  dskg_rd_pipeline: "R&D 파이프라인",
  dskg_filing_search: "공시 원문 검색",
  dskg_disclosure_events: "수시공시 이력",
  dskg_company_news_timeline: "뉴스 궤적",
  dskg_keyword_news_timeline: "키워드 뉴스 추이",
  dskg_keyword_universe: "키워드 유니버스",
  dskg_trending_terms: "뜨는 키워드",
  dskg_monthly_hot_keywords: "월간 인기 키워드",
  dskg_monthly_hot_companies: "월간 인기 종목",
  dskg_theme_revenue_evidence: "테마 매출 근거",
  dskg_similar_companies: "유사기업",
  dskg_thematic_purity: "테마 순도",
  dskg_momentum_screener: "모멘텀 스크리닝",
  dskg_fundamental_screener: "재무 스크리닝",
  dskg_price_factor_scanner: "주가 팩터 스캔",
  dskg_sentiment_movers: "심리 변동 종목",
  dskg_ownership_network: "지분 관계",
  dskg_ownership_movers: "지분 변동",
  dskg_nps_holdings: "국민연금 보유",
  dskg_shareholder_portfolio: "주주 포트폴리오",
  dskg_corporate_investors: "법인 투자자",
  dskg_group_affiliates: "계열사",
  dskg_subsidiary_tree: "종속회사 구조",
  dskg_controlling_chain: "지배구조 사슬",
  dskg_connection_map: "연결 관계도",
  dskg_portfolio_exposure: "포트폴리오 노출도",
  dskg_macro_indicator: "매크로 지표",
  dskg_search_theme: "테마 검색",
  dskg_vocabulary: "용어 사전",
  dskg_guide: "Graph DB 사용법",
};

export const toolLabel = (t: string): string => TOOL_LABELS[t] || t;
